const LINE_REGISTER_ENTRY_SOURCE_KEY = "wizmate.line-register.entry-source.v1";
const LEGACY_WEB_APP_LINE_REGISTER_ENTRY_KEY = "wizmate.line-register.web-app-entry.v1";

export type LineRegisterEntrySource = "webApp" | "lineVersion";

function persistLineRegisterEntrySource(source: LineRegisterEntrySource) {
  localStorage.setItem(LINE_REGISTER_ENTRY_SOURCE_KEY, source);
  sessionStorage.setItem(LINE_REGISTER_ENTRY_SOURCE_KEY, source);
}

export function markWebAppLineRegisterEntry() {
  persistLineRegisterEntrySource("webApp");
}

export function markLineVersionRegisterEntry() {
  persistLineRegisterEntrySource("lineVersion");
}

export function consumeLineRegisterEntrySource(): LineRegisterEntrySource | null {
  const source =
    localStorage.getItem(LINE_REGISTER_ENTRY_SOURCE_KEY) ??
    sessionStorage.getItem(LINE_REGISTER_ENTRY_SOURCE_KEY);

  localStorage.removeItem(LINE_REGISTER_ENTRY_SOURCE_KEY);
  sessionStorage.removeItem(LINE_REGISTER_ENTRY_SOURCE_KEY);

  if (source === "webApp" || source === "lineVersion") {
    localStorage.removeItem(LEGACY_WEB_APP_LINE_REGISTER_ENTRY_KEY);
    sessionStorage.removeItem(LEGACY_WEB_APP_LINE_REGISTER_ENTRY_KEY);
    return source;
  }

  const isLegacyWebAppEntry =
    localStorage.getItem(LEGACY_WEB_APP_LINE_REGISTER_ENTRY_KEY) === "true" ||
    sessionStorage.getItem(LEGACY_WEB_APP_LINE_REGISTER_ENTRY_KEY) === "true";

  localStorage.removeItem(LEGACY_WEB_APP_LINE_REGISTER_ENTRY_KEY);
  sessionStorage.removeItem(LEGACY_WEB_APP_LINE_REGISTER_ENTRY_KEY);

  return isLegacyWebAppEntry ? "webApp" : null;
}

export function readLineRegisterEntrySource(): LineRegisterEntrySource | null {
  const source =
    localStorage.getItem(LINE_REGISTER_ENTRY_SOURCE_KEY) ??
    sessionStorage.getItem(LINE_REGISTER_ENTRY_SOURCE_KEY);

  if (source === "webApp" || source === "lineVersion") {
    return source;
  }

  const isLegacyWebAppEntry =
    localStorage.getItem(LEGACY_WEB_APP_LINE_REGISTER_ENTRY_KEY) === "true" ||
    sessionStorage.getItem(LEGACY_WEB_APP_LINE_REGISTER_ENTRY_KEY) === "true";

  return isLegacyWebAppEntry ? "webApp" : null;
}
